
    import './styles.scoped.css';
    export default {
  "calendar": "awsui_calendar_mgja0_1mmnk_93",
  "awsui-motion-fade-in-0": "awsui_awsui-motion-fade-in-0_mgja0_1mmnk_1",
  "root": "awsui_root_mgja0_1mmnk_120",
  "focus-lock": "awsui_focus-lock_mgja0_1mmnk_132",
  "trigger-wrapper": "awsui_trigger-wrapper_mgja0_1mmnk_136",
  "trigger-flexbox": "awsui_trigger-flexbox_mgja0_1mmnk_140",
  "calendar-container": "awsui_calendar-container_mgja0_1mmnk_144",
  "one-grid": "awsui_one-grid_mgja0_1mmnk_147",
  "calendar-header": "awsui_calendar-header_mgja0_1mmnk_151",
  "calendar-header-months-wrapper": "awsui_calendar-header-months-wrapper_mgja0_1mmnk_157",
  "calendar-header-month": "awsui_calendar-header-month_mgja0_1mmnk_157",
  "calendar-next-month-btn": "awsui_calendar-next-month-btn_mgja0_1mmnk_178",
  "calendar-prev-month-btn": "awsui_calendar-prev-month-btn_mgja0_1mmnk_181",
  "first-grid": "awsui_first-grid_mgja0_1mmnk_185",
  "second-grid": "awsui_second-grid_mgja0_1mmnk_186",
  "date-and-time-container": "awsui_date-and-time-container_mgja0_1mmnk_190",
  "date-and-time-wrapper": "awsui_date-and-time-wrapper_mgja0_1mmnk_196",
  "footer": "awsui_footer_mgja0_1mmnk_203",
  "has-clear-button": "awsui_has-clear-button_mgja0_1mmnk_210",
  "footer-button-wrapper": "awsui_footer-button-wrapper_mgja0_1mmnk_217",
  "icon-wrapper": "awsui_icon-wrapper_mgja0_1mmnk_221",
  "label": "awsui_label_mgja0_1mmnk_226",
  "label-enabled": "awsui_label-enabled_mgja0_1mmnk_231",
  "label-text": "awsui_label-text_mgja0_1mmnk_235",
  "label-token-nowrap": "awsui_label-token-nowrap_mgja0_1mmnk_240",
  "mode-switch": "awsui_mode-switch_mgja0_1mmnk_244",
  "dropdown": "awsui_dropdown_mgja0_1mmnk_248",
  "dropdown-content": "awsui_dropdown-content_mgja0_1mmnk_264",
  "start-date-input": "awsui_start-date-input_mgja0_1mmnk_273",
  "start-time-input": "awsui_start-time-input_mgja0_1mmnk_274",
  "end-date-input": "awsui_end-date-input_mgja0_1mmnk_275",
  "end-time-input": "awsui_end-time-input_mgja0_1mmnk_276",
  "validation-section": "awsui_validation-section_mgja0_1mmnk_280",
  "validation-error": "awsui_validation-error_mgja0_1mmnk_284",
  "clear-button": "awsui_clear-button_mgja0_1mmnk_288",
  "apply-button": "awsui_apply-button_mgja0_1mmnk_292",
  "cancel-button": "awsui_cancel-button_mgja0_1mmnk_296",
  "calendar-aria-live": "awsui_calendar-aria-live_mgja0_1mmnk_300"
};
  